export default __webpack_public_path__ + "static/media/logo1.f8356787.png";